import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export const buttonVariants = cva(twMerge(['rounded-full', 'w-fit', 'p-0']), {
  variants: {
    variant: {
      primary:
        'bg-emerge-teal text-dark-navy-30 hover:bg-dark-teal-30 focus:outline-none active:ring active:ring-aux-gray',
      primary_inverted:
        'border border-emerge-teal bg-white text-emerge-navy hover:bg-dark-teal-30 focus:outline-none active:ring active:ring-aux-gray',
      secondary:
        'border border-gray-200 text-dark-navy-30 bg-white hover:bg-emerge-base-2 active:bg-emerge-base-2 focus:ring focus:ring-aux-gray focus:bg-emerge-base-2 focus:outline-none',
      tertiary: 'bg-emerge-teal-3 text-dark-navy-30',
      xero: 'bg-brand-xero text-white',
      error: 'bg-emerge-orange-3 text-error-darkred',
      secondary_alternative: 'border border-gray-200 text-dark-navy-30 bg-white',
      ghost: 'bg-transparent border-none text-dark-navy-30 hover:bg-transparent',
      disabled: 'text-dark-base-90 border-aux-disablegray bg-aux-disablegray cursor-not-allowed'
    },
    size: {
      sm: 'text-xs h-7 p-0 px-0',
      md: 'text-sm h-9 p-0',
      lg: 'text-xs h-9 w-full max-w-32',
      // The one standard "action pill" - uniform 16px padding, height driven by content instead
      // of a fixed h-*. Use this instead of composing padding ad-hoc per call site; every button
      // using it gets the exact same padding, with no room for per-instance drift.
      pill: 'text-xs h-auto p-4'
    },
    fontSize: {
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold'
    }
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
    fontSize: 'medium'
  }
});
